(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('Acuity', Acuity);

    Acuity.$inject = ['$resource'];

    function Acuity ($resource) {
        var resourceUrl =  'api/acuities/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'findAllByCorporation': {url: 'api/acuities/by-corporation/:id', method: 'GET', isArray: true}
        });
    }
})();
